import * as React from 'react';
import { cn } from './lib/utils';

const GRID_CLASSES = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 md:grid-cols-2',
  3: 'grid-cols-1 md:grid-cols-3',
  4: 'grid-cols-2 xl:grid-cols-4',
  5: 'grid-cols-2 lg:grid-cols-5',
  8: 'grid-cols-4 lg:grid-cols-8',
};

/**
 * Responsive grid container for KPICard arrays.
 *
 * <KPIGrid columns={4}>
 *   <KPICard ... />
 *   <KPICard ... />
 * </KPIGrid>
 */
function KPIGrid({ columns = 4, children, className }) {
  return (
    <div className={cn('grid gap-2', GRID_CLASSES[columns] ?? GRID_CLASSES[4], className)}>
      {children}
    </div>
  );
}

export { KPIGrid };
